import { closePopup } from "@/helper/DxHelper";
import { Popup } from "devextreme-react";
import RebalancesGrid from "./RebalancesGrid";
import { useQueryClient } from "@tanstack/react-query";
import PrintRebalancesButton from "./PrintRebalancesButton";
import { Rebalance } from "@/types/types";
import { CrossIcon, RefreshIcon } from "@/components/Icons";
import { PopupRef } from "devextreme-react/cjs/popup";

type Props = {
  popupRef: React.RefObject<PopupRef>;
  rebalances: Rebalance[];
};

function RebalancesPopup({ popupRef, rebalances }: Props) {
  const qc = useQueryClient();

  return (
    <Popup
      ref={popupRef}
      showTitle={false}
      onHiding={() => closePopup(popupRef)}
      onShowing={(e) => {
        const el = e.component.content();
        el.style.padding = "32px";
      }}
      width={1300}
      className="flex items-center justify-center print:w-screen"
    >
      <div className="flex h-7 items-center justify-between">
        <h2 className="line-clamp-5 text-2xl font-medium leading-7">Rebalance History</h2>
        <div className="relative flex items-center">
          <button
            className={`shadow-[0px_4px_4px_0px_#00000026 hover:bg-primary relative flex h-10 w-10 items-center justify-center rounded-[4px] transition-all duration-300 hover:shadow-default [&>svg]:transition-all [&>svg]:hover:stroke-white`}
            onClick={() => {
              qc.invalidateQueries({
                queryKey: ["strategic-guide"],
              });
            }}
          >
            {RefreshIcon}
          </button>
          <button
            className={`shadow-[0px_4px_4px_0px_#00000026 hover:bg-primary relative left-2 flex h-10 w-10 items-center justify-center rounded-[4px] transition-all duration-300 hover:shadow-default [&>svg]:transition-all [&>svg]:hover:fill-white`}
            onClick={() => closePopup(popupRef)}
          >
            {CrossIcon}
          </button>
        </div>
      </div>
      <div className="py-4" />
      <RebalancesGrid rebalances={rebalances} />
      <PrintRebalancesButton />
    </Popup>
  );
}

export default RebalancesPopup;
